import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  isEntireDocReaded: false,
  pendingPrivacyNotice: null,
};

const privacyNoticeOnboardingSlice = createSlice({
  name: 'privacyNoticeOnboarding',
  initialState,
  reducers: {
    setPrivacyNoticeOnboardingState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPrivacyNoticeOnboardingState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => initialState);
  },
});

export const {
  setPrivacyNoticeOnboardingState,
  resetPrivacyNoticeOnboardingState,
} = privacyNoticeOnboardingSlice.actions;
export default privacyNoticeOnboardingSlice.reducer;
